/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ElConfigProvider } from 'element-plus';
import 'element-plus/es/components/config-provider/style/index'

import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useGlobalConfigStore } from '@/store/module/globalConfig';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const locale = zhCn;
    useGlobalConfigStore().getBrandList();
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});